import { useState } from 'react';
import { getTemplatesIcon } from './utils';
import BasicCellText from './BasicCellText';

const TemplateColumns = (columnWidths, type) => {
	const [openTooltip, setOpenTooltip] = useState(0);

	return [
		{
			field: 'appId',
			headerName: 'Template ID',
			description: 'Template ID',
			renderCell: (cellValues) => (
				<BasicCellText
					isLink
					cellValues={cellValues}
					emptyCell
					openTooltip={openTooltip}
					setOpenTooltip={setOpenTooltip}
					StartIcon={getTemplatesIcon(type)}
					is_ID={true}
				/>
			),
			flex: columnWidths.appId || 1,
			resizable: true
		},
		{
			field: 'title',
			headerName: 'Template Title',
			description: 'Template Title',
			renderCell: (cellValues) => <>{cellValues?.formattedValue}</>,
			flex: !columnWidths.title && 1
		},
		{
			field: 'description',
			headerName: 'Description',
			description: 'Description',
			renderCell: (cellValues) => (
				<BasicCellText
					isLink
					cellValues={cellValues}
					openTooltip={openTooltip}
					setOpenTooltip={setOpenTooltip}
				/>
			),
			flex: columnWidths.description || 1,
			resizable: true
		},
		{
			field: 'published',
			headerName: 'Published',
			description: 'Published',
			renderCell: (cellValues) => (
				<BasicCellText
					openTooltip={openTooltip}
					setOpenTooltip={setOpenTooltip}
					cellValues={cellValues}
					isDate
				/>
			),
			flex: columnWidths.published || 1,
			minWidth: 100,
			resizable: true
		},
		{
			field: 'updated',
			headerName: 'Updated',
			description: 'Updated',
			renderCell: (cellValues) => (
				<BasicCellText
					openTooltip={openTooltip}
					setOpenTooltip={setOpenTooltip}
					cellValues={cellValues}
					isDate
				/>
			),
			flex: columnWidths.updated || 1,
			minWidth: 100,
			resizable: true
		}
	];
};

export default TemplateColumns;
